module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"profile_image":"Profile Image","change_image":"Change images","error_occurred":"An error has occurred.","cancel":"Cancel","save":"Update","user_name":"User name","file_type":"File type：JPG, PNG","file_size":"File size：600px or less 30kb or less","dont_empty_user_name":"Don\u0027t empty user name","invaild_image":"extension is not supported.","updated":"Updated."}}')
  delete Component.options._Ctor
}
